import styles from './TSort.module.scss';
import {DisplayedByNum} from "../SortByNum";
import {DisplayedByName} from "../SortByName";
import {useNavigate} from "react-router-dom";

export const TSort = ({setSortField, handleLimitChange, perPage, title, navigateUrl, searchOptions}) => {
    const navigate = useNavigate();

    const onClickHandler = () => {
        navigate(navigateUrl)
    }

    return (
        <div className={styles['table-header__wrapper']}>
            <DisplayedByName setSortField={setSortField} searchOptions={searchOptions}/>

            <div>
                {title &&
                <div className={styles['create__button']}>
                    <button onClick={onClickHandler}>{title}</button>
                </div> }
                <DisplayedByNum handleLimitChange={handleLimitChange} perPage={perPage}/>
            </div>

        </div>
    );
};